import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Grid,
  IconButton,
  Tooltip,
} from "@mui/material";
import axios from "axios";
import { useEffect, useState, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import AccordianContainer from "../CustomComponents/AccordianContainer";
import CustomAutoComplete from "../CustomComponents/CustomAutoComplete";
import CustomDateField from "../CustomComponents/CustomDateField";
import CustomDropDown from "../CustomComponents/CustomDropDown";
import CustomTextField from "../CustomComponents/CustomTextField";
import GetBranchDetails from "../CustomComponents/GetBranchDetails";
import { FileReceiptGridReducerAction } from "../Store/FileReceiptGridReducer";
import { Edit, Preview } from "@mui/icons-material";
import store from "./../Store/index";
import { SpecialAccessDetailAction } from "../Store/SpecialAccess/SpecialAccessDetailReducer";
import { BranchAction } from "../Store/Branch";
import dayjs from "dayjs";
import { CommonShortCutAction } from "../Store/CommonShortCutsReducer";
import GetBranchDetailsWithCode from "../CustomComponents/GetBranchDetailsWithCode";

const BasicReceiptInfo = (props) => {
  //Importing Hooks
  const dispatch = useDispatch();
  //Selectors from redux store
  const saveDone = useSelector((state) => state.fileReceiptGrid.saveDone);
  const receiptTypeValue = useSelector(
    (state) => state.fileReceiptGrid.receiptType
  );
  const thirdPartyNameDisable = useSelector(
    (state) => state.fileReceiptGrid.thirdPartyNameDisableModeFlag
  );
  const fileReceiptInitialState = useSelector(
    (state) => state.fileReceiptGrid.fileReceiptInitialState
  );
  const fileReceiptInitialStateAfterFilter = useSelector(
    (state) => state.fileReceiptGrid.fileReceiptInitialStateAfterFilter
  );

  const specialAccessHeaderMap = useSelector(
    (state) => state.specialAccess.specialAccessHeaderMap
  );

  const fileReceiptLovData = useSelector(
    (state) => state.fileReceiptGrid.fileReceiptLovData
  );

  const prepayReceiptMode = useSelector(
    (state) => state.fileReceiptGrid.prepayReceiptMode
  );

  const [accodianOpen, setAccordianOpen] = useState(true);
  const [branchNames, setbranchNames] = useState([]);
  const [disableFields, setDisabledFields] = useState(false);
  const [receiptTypeValues, setReceiptTypeValues] = useState([]);
  const [applicationNumValues, setApplicationNumArray] = useState([]);
  const [customerIdValues, setCustomerIdValues] = useState([]);
  const [voucherNums, setVoucherNumArray] = useState([]);

  const userId = store.getState().branch.userID;
  const moduleId = useSelector((state) => state.specialAccess.moduleId);
  const programId = useSelector((state) => state.specialAccess.programId);
  let fieldAccessMap = useSelector(
    (state) => state.specialAccess.fieldAccessMap
  );
  let paramValues = useSelector((state) => state.specialAccess.paramValues);
  //Branch onChangeHandler
  useEffect(() => {
    getFieldData();
  }, []);

  const getFieldData = async () => {
    let modeIdVal = "";
    const response = await axios.get("/specialAccess/getFieldAccess", {
      method: "get",
      params: {
        userId: userId,
        moduleId: moduleId,
        programId: programId,
        modeId: modeIdVal,
      },
    });
    dispatch(SpecialAccessDetailAction.getFieldData(response.data));
  };

  let minDateAddValue = Number(0);
  let maxDateAddValue = Number(0);

  if (
    paramValues !== null &&
    paramValues !== undefined &&
    Object.keys(paramValues).length > 0
  ) {
    if (
      !(
        paramValues["Receipt Request Date Back Count"] &&
        new Date(
          paramValues["Receipt Request Date Back Count"]["paramEffStartDate"]
        ) <= new Date(dayjs(new Date()).format("MM/DD/YYYY")) &&
        new Date(
          paramValues["Receipt Request Date Back Count"]["paramEffEndDate"]
        ) >= new Date(dayjs(new Date()).format("MM/DD/YYYY"))
      )
    ) {
      minDateAddValue = 0;
    } else {
      minDateAddValue =
        fieldAccessMap.receiptCreateVoucherDate &&
        fieldAccessMap.receiptCreateVoucherDateBackCount
          ? Number(paramValues["Receipt Request Date Back Count"]["paramValue"])
          : Number(0);
    }
    if (
      !(
        paramValues["Receipt Request Date Future Count"] &&
        new Date(
          paramValues["Receipt Request Date Future Count"]["paramEffStartDate"]
        ) <= new Date(dayjs(new Date()).format("MM/DD/YYYY")) &&
        new Date(
          paramValues["Receipt Request Date Future Count"]["paramEffEndDate"]
        ) >= new Date(dayjs(new Date()).format("MM/DD/YYYY"))
      )
    ) {
      maxDateAddValue = 0;
    } else {
      maxDateAddValue =
        fieldAccessMap.receiptCreateVoucherDate &&
        fieldAccessMap.receiptCreateVoucherDateFutureCount
          ? Number(
              paramValues["Receipt Request Date Future Count"]["paramValue"]
            )
          : Number(0);
    }
  }
  //State to maintain display 3rd part applicant Name

  const thirdPartyNameDisplayFlag = useSelector(
    (state) => state.fileReceiptGrid.thirdPartyNameDisplayFlag
  );
  // Dialog msg content.
  const [dialogMessage, setDialogMessage] = useState("");
  const [dialogTitleMessage, setDialogTitleMessage] = useState("");
  //Maintainig State for Dialog while submitting the application
  const [open, setOpen] = useState(false);

  // Dialog msg content.
  const [modeSwitchDialogMessage, setModeSwitchDialogMessage] = useState("");
  const [modeSwitchDialogTitleMessage, setModeSwitchDialogTitleMessage] =
    useState("");
  //Maintainig State for Dialog while submitting the application
  const [modeSwitchDlgOpen, setModeSwitchDlgOpen] = useState(false);
  const [modeSwitchToView, setModeSwitchToView] = useState(false);

  //validation
  const [branchHasError, setBranchHasError] = useState(false);
  const [receiptForHasError, setReceiptForHasError] = useState(false);
  const [applicationNumberHasError, setApplicationNumberHasError] =
    useState(false);
  const [customerIdHasError, setCustomerIdHasError] = useState(false);
  const [receiptTypeHasError, setReceiptTypeHasError] = useState(false);
  const [voucherNumberHasError, setVoucherNumberHasError] = useState(false);
  const voucherDateValidDateError = useSelector(
    (state) => state.fileReceiptGrid.voucherDateValidDateError
  );

  const [currentfieldTrigger, setCurrentFieldTrigger] = useState({});
  const dateEnableDetails = useSelector(
    (state) => state.fileReceiptGrid.dateEnableDetails
  );

  //shortcut key
  const yesRef = useRef(null);
  const cancelRef = useRef(null);
  const clearRef = useRef(null);
  const searchButtonRef = useRef(null);
  const viewRef = useRef(null);
  const modifyRef = useRef(null);
  const cancelModeRef = useRef(null);
  const yesModeRef = useRef(null);
  useEffect(() => {
    window.addEventListener("keydown", onKeyUnmountEventHandler);
    window.addEventListener("keyup", onKeyPressEventHandler);
    return () => {
      window.removeEventListener("keydown", onKeyUnmountEventHandler);
      window.removeEventListener("keyup", onKeyPressEventHandler);
    };
  }, []);
  const onKeyUnmountEventHandler = (event) => {
    if (event.ctrlKey) {
      dispatch(
        CommonShortCutAction.removeDefaultShortCutValue({
          event: event,
          screen: "basicReceipt",
        })
      );
    }
  };
  const onKeyPressEventHandler = (event) => {
    let charCode = String.fromCharCode(event.which).toLowerCase();
    let date = new Date();
    if (event.ctrlKey) {
      switch (charCode) {
        case "y":
          yesModeRef.current !== null && yesModeRef.current.click();
          yesRef.current !== null && yesRef.current.click();
          break;
        case "q":
          event.preventDefault();
          cancelRef.current !== null && cancelRef.current.click();
          cancelModeRef.current !== null && cancelModeRef.current.click();
          break;
        case "d":
          clearRef.current !== null && clearRef.current.click();
          break;
        case "f":
          searchButtonRef.current.click();
          break;
        case "e":
          viewRef.current.click();
          break;
        case "m":
          modifyRef.current.click();
          break;

        default:
          break;
      }
    }
  };
  useEffect(() => {
    const loadBranchNames = GetBranchDetails();
    setbranchNames(loadBranchNames);
    if (loadBranchNames.length === 1) {
      onBranchChange(loadBranchNames[0], false);
    }
    const checkScreenMode = async () => {
      if (props.screenMode === "MODIFY" || props.screenMode === "VIEW") {
        setDisabledFields(true);
      }
    };
    checkScreenMode();
  }, [props.screenMode, fileReceiptLovData]);

  useEffect(() => {
    // on initial page load -> load the File receipt Module LOV Master Values.
    const getLovMasterData = async () => {
      const fileReceiptLovValues = await axios.post("/lovMaster/getLovValues", {
        moduleId: "MD004",
      });
      const lovData = fileReceiptLovValues.data;
      dispatch(FileReceiptGridReducerAction.updateLovDataValue(lovData));
      const targetFieldsData = Object.keys(lovData);
      dispatch(
        FileReceiptGridReducerAction.updateLovTargetFields(targetFieldsData)
      );
    };
    getLovMasterData();
  }, []);

  const getSelectedBranchCode = (branchValue) => {
    const branchWithCodes = GetBranchDetailsWithCode();
    const branchCodeValue = branchWithCodes.find((branch) => {
      return branch.label === branchValue;
    });
    return branchCodeValue.code;
  };

  const onBranchChange = async (value, pageredirection) => {
    // reset the store .
    dispatch(FileReceiptGridReducerAction.resetGridRows());
    setReceiptTypeValues([]);
    dispatch(FileReceiptGridReducerAction.updateSourceOfFundValues([]));
    try {
      let appnums = [];
      if (value && value !== "") {
        dispatch(BranchAction.updateHeaderBranchDetails(value.label));
        const branchCodeValue = getSelectedBranchCode(value.label);
        const response = await axios.post("/losCustomer/getAppListByBranch", {
          branchName: value.label,
          branchCode: branchCodeValue,
          screenMode: props.screenMode,
        });
        const customerIds = await axios.post(
          "/losCustomer/getCustomerIdListByBranch",
          {
            branchName: value.label,
            branchCode: branchCodeValue,
          }
        );
        appnums = [...response.data];
        setApplicationNumArray([...appnums]);
        const custIds = [...customerIds.data].map((custid) => String(custid));
        setCustomerIdValues([...custIds]);
      } else {
        setApplicationNumArray(appnums);
        setCustomerIdValues([]);
        setVoucherNumArray([]);
      }
    } catch (error) {
      console.log(error);
    }
    props.dispatch({
      type: props.fileReceiptScreenFields.branch,
      value: value === null ? value : value.label,
    });
  };

  const onChangeByAppNum = async (value, pageredirection) => {
    dispatch(FileReceiptGridReducerAction.resetGridRows());
    setReceiptTypeValues([]);
    dispatch(FileReceiptGridReducerAction.updateSourceOfFundValues([]));
    try {
      props.dispatch({
        type: props.fileReceiptScreenFields.applicationNum,
        value: value === null ? "" : value,
      });
      if (value && value !== "") {
        const response = await axios.post(
          "/losCustomer/getCustomerDataByAppNum",
          {
            applicationNum: value,
          }
        );
        let record = response.data;
        let receiptTypeArray = [];
        if (value && value !== "") {
          receiptTypeArray = fileReceiptLovData?.lovDataValue?.[
            "Receipt Type"
          ].map((record) => record.lovValues);
          setReceiptTypeValues([...receiptTypeArray]);
        } else {
          setReceiptTypeValues(receiptTypeArray);
        }
        let fundValues = [];
        if (value && value !== "") {
          fundValues = fileReceiptLovData?.lovDataValue?.["Source of Fund"].map(
            (record) => record.lovValues
          );
        }
        dispatch(
          FileReceiptGridReducerAction.updateSourceOfFundValues([...fundValues])
        );
        dispatch(
          FileReceiptGridReducerAction.updateCurrentReceiptCustomerData(record)
        );
        // when for application status is sancationed or requested -> we should not allow to config the Emi receipt Gl or prepay configuration

        if (props.screenMode !== "VIEW") {
          // means not allow to do on create or modify modes.
          if (
            record.losStatus === "Sanctioned" ||
            record.losStatus === "Requested"
          ) {
            dispatch(
              FileReceiptGridReducerAction.updatePrePayReceiptMode(false)
            );
          }
        }

        if (props.screenMode === "CREATE") {
          props.dispatch({
            type: props.fileReceiptScreenFields.customerName,
            value: record.customerName,
          });
          props.dispatch({
            type: props.fileReceiptScreenFields.disbStatus,
            value: record.losStatus,
          });
        } else {
          // for modify mode & view mode load the voucher nums based on application num.
          const branchCodeValue = getSelectedBranchCode(
            props.fileReceiptState.branch
          );
          const voucherList = await axios.post("/filereceipt/getVoucherList", {
            branch: props.fileReceiptState.branch,
            branchCode: branchCodeValue,
            applicationNum: value,
            receiptFor: props.fileReceiptState.receiptFor,
            screenMode: props.screenMode,
          });
          setVoucherNumArray(voucherList.data);
          // trigger request to get data based on voucher number.
          if (pageredirection) {
            onChangeVoucherNum(props.fileReceiptState.voucherNum);
          }
        }
      } else {
        if (value === null || value === undefined || value === "") {
          setVoucherNumArray([]);
        }
      }
    } catch (error) {
      console.log(error);
      props.dispatch({
        type: props.fileReceiptScreenFields.applicationNum,
        value: value === null ? "" : value,
      });
      if (value === null || value === undefined || value === "") {
        setVoucherNumArray([]);
      }
    }
  };

  const onChangeVoucherNum = async (value) => {
    try {
      const receiptResponse = await axios.post(
        "/filereceipt/getFileReceiptData",
        {
          voucherNumber: value,
        }
      );
      let responseReceiptData = receiptResponse.data;
      let gridrecords = responseReceiptData.favourList.map((row, index) => {
        row.id = index;
        return row;
      });
      dispatch(FileReceiptGridReducerAction.resetGridRows());
      dispatch(FileReceiptGridReducerAction.updateInitialLoad(true));
      dispatch(FileReceiptGridReducerAction.updateGridRows([...gridrecords]));
      let receiptData = { ...responseReceiptData };
      const currentStateValue = { ...props.fileReceiptState };
      receiptData.receiptFor = currentStateValue.receiptFor;
      props.dispatch({
        type: "viewOrModifyModeLoad",
        value: receiptData,
      });
      dispatch(
        FileReceiptGridReducerAction.updatePrePayReceiptMode(
          receiptData.prepayReceiptMode
        )
      );
      dispatch(
        FileReceiptGridReducerAction.updatePrepayReason(
          receiptData.prepayReason
        )
      );
      dispatch(
        FileReceiptGridReducerAction.updateBankAndInstructions(
          receiptData.bankAndInstructions
        )
      );
      dispatch(
        FileReceiptGridReducerAction.updateTakeOverReason(
          receiptData.takeOverReason
        )
      );
      dispatch(
        FileReceiptGridReducerAction.updatePrepayEffectiveDate(
          receiptData.effectiveDate
        )
      );
      dispatch(
        FileReceiptGridReducerAction.updatePrepayNarration(
          receiptData.prepayNarration
        )
      );
      setReceiptTypeHasError(false);
    } catch (error) {
      console.log(error);
      throw Error(error);
    }
  };

  const resetValuesOnReceiptTypeChange = () => {
    dispatch(FileReceiptGridReducerAction.resetGridRows());
    dispatch(FileReceiptGridReducerAction.updateInitialLoad(true));
    dispatch(FileReceiptGridReducerAction.updateSaveDone(false));
    dispatch(FileReceiptGridReducerAction.updatePrePayReceiptMode(false));
    dispatch(FileReceiptGridReducerAction.resetPrepayDetails());
    props.dispatch({
      type: props.fileReceiptScreenFields.sourceOfFund,
      value: null,
    });
    props.dispatch({
      type: props.fileReceiptScreenFields.thirdPartyName,
      value: "",
    });
  };

  const handleOk = () => {
    resetValuesOnReceiptTypeChange();
    setOpen(false);
    props.goClickEvent(false);
    if (
      currentfieldTrigger.field === props.fileReceiptScreenFields.sourceOfFund
    ) {
      dispatch(FileReceiptGridReducerAction.updateReceiptType(null));
      props.dispatch({
        type: props.fileReceiptScreenFields.receiptType,
        value: null,
      });
    }

    if (
      currentfieldTrigger.field === props.fileReceiptScreenFields.applicationNum
    ) {
      onChangeByAppNum(currentfieldTrigger.value, false);
    } else {
      props.dispatch({
        type: currentfieldTrigger.field,
        value: currentfieldTrigger.value,
      });
    }

    if (
      currentfieldTrigger.field === props.fileReceiptScreenFields.sourceOfFund
    ) {
      setCurrentFieldTrigger({});
      dispatch(
        FileReceiptGridReducerAction.updateFileReceiptInitialStateAfterFilter(
          {}
        )
      );
    }

    // if any other fields reset the values so we need to clear this.
    dispatch(
      FileReceiptGridReducerAction.updateFileReceiptInitialStateAfterFilter({})
    );
  };

  const handleClose = () => {
    setOpen(false);
  };

  const onChangeByReceiptFor = async (value) => {
    dispatch(FileReceiptGridReducerAction.resetGridRows());
    setReceiptTypeValues([]);
    dispatch(FileReceiptGridReducerAction.updateSourceOfFundValues([]));
    let appnums = [];
    const currentBranchValue = props.fileReceiptState.branch;
    if (currentBranchValue && currentBranchValue !== "") {
      const branchCodeValue = getSelectedBranchCode(currentBranchValue);
      const response = await axios.post("/losCustomer/getAppListByBranch", {
        branchName: props.fileReceiptState.branch,
        branchCode: branchCodeValue,
        screenMode: props.screenMode,
      });
      const customerIds = await axios.post(
        "/losCustomer/getCustomerIdListByBranch",
        {
          branchName: props.fileReceiptState.branch,
          branchCode: branchCodeValue,
        }
      );
      appnums = [...response.data];
      setApplicationNumArray([...appnums]);
      const custIds = [...customerIds.data].map((custid) => String(custid));
      setCustomerIdValues([...custIds]);
    } else {
      appnums = [];
      setApplicationNumArray([...appnums]);
      setCustomerIdValues([]);
      setVoucherNumArray([]);
    }

    if (value === null || value === undefined || value === "") {
      setVoucherNumArray([]);
    }
    props.dispatch({
      type: props.fileReceiptScreenFields.receiptFor,
      value: value === null ? "" : value,
    });
  };

  const onChangeByCustomerId = async (value) => {
    dispatch(FileReceiptGridReducerAction.resetGridRows());
    setApplicationNumArray([]);
    setReceiptTypeValues([]);
    dispatch(FileReceiptGridReducerAction.updateSourceOfFundValues([]));
    let fundValues = [];
    if (value && value !== "") {
      fundValues = fileReceiptLovData?.lovDataValue?.["Source of Fund"].map(
        (record) => record.lovValues
      );
    }
    dispatch(
      FileReceiptGridReducerAction.updateSourceOfFundValues([...fundValues])
    );
    const receiptTypeArray = fileReceiptLovData?.lovDataValue?.[
      "Receipt Type"
    ].map((record) => record.lovValues);
    setReceiptTypeValues([...receiptTypeArray]);
    props.dispatch({
      type: props.fileReceiptScreenFields.customerId,
      value: value === null ? "" : value,
    });
    try {
      let appnums = [];
      if (value && value !== "") {
        const response = await axios.post(
          "/losCustomer/getApplicationByCustomerId",
          {
            customerId: value,
          }
        );
        appnums = [...response.data.applicationNum];
        setApplicationNumArray([...appnums]);
        if (props.screenMode !== "CREATE") {
          const branchCodeValue = getSelectedBranchCode(
            props.fileReceiptState.branch
          );
          const voucherList = await axios.post(
            "/filereceipt/getVoucherListForCustId",
            {
              branch: props.fileReceiptState.branch,
              branchCode: branchCodeValue,
              customerId: value,
              receiptFor: props.fileReceiptState.receiptFor,
              screenMode: props.screenMode,
            }
          );
          setVoucherNumArray(voucherList.data);
        }

        props.dispatch({
          type: props.fileReceiptScreenFields.customerId,
          value: value === null ? "" : value,
        });
        props.dispatch({
          type: props.fileReceiptScreenFields.customerName,
          value: response.data.customerName,
        });
      } else {
        setApplicationNumArray(appnums);
        props.dispatch({
          type: props.fileReceiptScreenFields.customerId,
          value: value === null ? "" : value,
        });
        if (value === null || value === undefined || value === "") {
          setVoucherNumArray([]);
        }
      }
    } catch (error) {
      console.log(error);
      props.dispatch({
        type: props.fileReceiptScreenFields.customerId,
        value: value === null ? "" : value,
      });
      if (value === null || value === undefined || value === "") {
        setVoucherNumArray([]);
      }
    }
  };

  const validateFieldsHandler = () => {
    let errorExist = false;
    if (
      props.fileReceiptState.branch !== "" &&
      props.fileReceiptState.branch !== null &&
      props.fileReceiptState.branch !== undefined
    ) {
      setBranchHasError(false);
    } else {
      errorExist = true;
      setBranchHasError(true);
    }
    if (
      props.fileReceiptState.receiptFor !== "" &&
      props.fileReceiptState.receiptFor !== null &&
      props.fileReceiptState.receiptFor !== undefined
    ) {
      setReceiptForHasError(false);
    } else {
      errorExist = true;
      setReceiptForHasError(true);
    }
    if (
      props.fileReceiptState.receiptFor === "Customer ID" &&
      props.fileReceiptState.customerId !== "" &&
      props.fileReceiptState.customerId !== null &&
      props.fileReceiptState.customerId !== undefined
    ) {
      setCustomerIdHasError(false);
    } else if (props.fileReceiptState.receiptFor === "Customer ID") {
      errorExist = true;
      setCustomerIdHasError(true);
    }
    if (
      props.fileReceiptState.receiptFor === "Application Number" &&
      props.fileReceiptState.applicationNum !== "" &&
      props.fileReceiptState.applicationNum !== null &&
      props.fileReceiptState.applicationNum !== undefined
    ) {
      setApplicationNumberHasError(false);
    } else if (props.fileReceiptState.receiptFor === "Application Number") {
      errorExist = true;
      setApplicationNumberHasError(true);
    }
    if (
      props.fileReceiptState.receiptType !== "" &&
      props.fileReceiptState.receiptType !== null &&
      props.fileReceiptState.receiptType !== undefined
    ) {
      setReceiptTypeHasError(false);
    } else {
      errorExist = true;
      setReceiptTypeHasError(true);
    }
    if (
      props.screenMode !== "CREATE" &&
      props.fileReceiptState.voucherNum !== "" &&
      props.fileReceiptState.voucherNum !== null &&
      props.fileReceiptState.voucherNum !== undefined
    ) {
      setVoucherNumberHasError(false);
    } else if (props.screenMode !== "CREATE") {
      errorExist = true;
      setVoucherNumberHasError(true);
    }

    if (!errorExist && !voucherDateValidDateError) {
      let currentStateValue = { ...props.fileReceiptState };
      currentStateValue.prepayReceiptMode =
        store.getState().fileReceiptGrid.prepayReceiptMode;
      let prepayDetailsData = store.getState().fileReceiptGrid.prePayDetails;
      currentStateValue = { ...currentStateValue, ...prepayDetailsData };
      dispatch(
        FileReceiptGridReducerAction.updateFileReceiptInitialStateAfterFilter(
          currentStateValue
        )
      );
      props.validateFieldsHandler();
      props.goClickEvent(true);
    }
  };

  const openAlertDialog = (fieldType, fieldValue) => {
    if (!saveDone) {
      setCurrentFieldTrigger({ field: fieldType, value: fieldValue });
      setDialogMessage(
        "Receipt Process Not Completed. Do you want to change and continue ?"
      );
      setDialogTitleMessage("Confirmation");
      setOpen(true);
    }
  };

  const onSwitchToViewMode = async () => {
    // before switch to view mode check for changes on the page.
    let currentStateValue = { ...props.fileReceiptState };
    currentStateValue.prepayReceiptMode =
      store.getState().fileReceiptGrid.prepayReceiptMode;
    currentStateValue.favourList = store.getState().fileReceiptGrid.gridRows;
    const prepayDetails = store.getState().fileReceiptGrid.prePayDetails;
    currentStateValue = {
      ...currentStateValue,
      ...prepayDetails,
    };
    const voucherNumValue = currentStateValue.voucherNum;
    if (voucherNumValue && voucherNumValue !== "") {
      // get the data for voucher Number from backend.
      try {
        const receiptResponse = await axios.post(
          "/filereceipt/getFileReceiptData",
          {
            voucherNumber: voucherNumValue,
          }
        );
        let responseReceiptData = receiptResponse.data;
        if (
          props.screenMode !== "VIEW" &&
          JSON.stringify(currentStateValue) !==
            JSON.stringify(responseReceiptData)
        ) {
          setModeSwitchToView(true);
          setModeSwitchDialogMessage(
            "Do you want to discard the changes and continue to View Mode ?"
          );
          setModeSwitchDialogTitleMessage("Confirmation");
          setModeSwitchDlgOpen(true);
        } else {
          // no changes exists then load the nums.
          const branchCodeValue = getSelectedBranchCode(
            currentStateValue.branch
          );
          const customerIds = await axios.post(
            "/losCustomer/getCustomerIdListByBranch",
            {
              branchName: currentStateValue.branch,
              branchCode: branchCodeValue,
            }
          );
          const custIds = [...customerIds.data].map((custid) => String(custid));
          setCustomerIdValues([...custIds]);

          const response = await axios.post("/losCustomer/getAppListByBranch", {
            branchName: currentStateValue.branch,
            branchCode: branchCodeValue,
            screenMode: "VIEW",
          });
          const appnums = [...response.data];
          setApplicationNumArray([...appnums]);

          dispatch(FileReceiptGridReducerAction.updateScreenMode("VIEW"));
        }
      } catch (error) {
        console.log(error);
        throw Error(error);
      }
    } else {
      // with out filling the voucher num also user can switch across the modes.
      // no changes exists then load the nums.
      if (currentStateValue.branch && currentStateValue.branch !== "") {
        const branchCodeValue = getSelectedBranchCode(currentStateValue.branch);
        const customerIds = await axios.post(
          "/losCustomer/getCustomerIdListByBranch",
          {
            branchName: currentStateValue.branch,
            branchCode: branchCodeValue,
          }
        );
        const custIds = [...customerIds.data].map((custid) => String(custid));
        setCustomerIdValues([...custIds]);

        const response = await axios.post("/losCustomer/getAppListByBranch", {
          branchName: currentStateValue.branch,
          branchCode: branchCodeValue,
          screenMode: "VIEW",
        });
        const appnums = [...response.data];
        setApplicationNumArray([...appnums]);
        dispatch(FileReceiptGridReducerAction.updateScreenMode("VIEW"));
      } else {
        dispatch(FileReceiptGridReducerAction.updateScreenMode("VIEW"));
      }
    }
  };

  const handleCloseForModeSwitch = () => {
    setModeSwitchToView(false);
    setModeSwitchDlgOpen(false);
  };

  const handleOkForModeSwitch = async () => {
    // get the data from backend & load.
    let currentStateValue = { ...props.fileReceiptState };
    const voucherNumValue = currentStateValue.voucherNum;
    await onChangeVoucherNum(voucherNumValue);
    // no changes exists then load the nums.
    const branchCodeValue = getSelectedBranchCode(currentStateValue.branch);
    const customerIds = await axios.post(
      "/losCustomer/getCustomerIdListByBranch",
      {
        branchName: currentStateValue.branch,
        branchCode: branchCodeValue,
      }
    );
    const custIds = [...customerIds.data].map((custid) => String(custid));
    setCustomerIdValues([...custIds]);

    const response = await axios.post("/losCustomer/getAppListByBranch", {
      branchName: currentStateValue.branch,
      branchCode: branchCodeValue,
      screenMode: "VIEW",
    });
    const appnums = [...response.data];
    setApplicationNumArray([...appnums]);

    setModeSwitchToView(false);
    setModeSwitchDlgOpen(false);
    dispatch(FileReceiptGridReducerAction.updateScreenMode("VIEW"));
  };

  const onSwitchToModifyMode = async () => {
    let currentStateValue = { ...props.fileReceiptState };
    if (
      currentStateValue.receiptType !== null &&
      currentStateValue.receiptType !== undefined &&
      currentStateValue.receiptType !== "" &&
      currentStateValue.receiptType === "CHEQUE"
    ) {
      const response = await axios.post(
        "/filereceipt/verifyChequeReturnFileReceiptData",
        {
          voucherNumber: currentStateValue.voucherNum,
        }
      );
      if (response.status === 206) {
        // means cheque already return -> 206 status.
        // for 200 status do nothing.
        setModeSwitchDialogMessage(
          "Cheque Already Returned so you can't Modify. Please Wait Redirecting to View Mode."
        );
        setModeSwitchDialogTitleMessage("Information");
        setModeSwitchDlgOpen(true);
        setTimeout(() => {
          dispatch(FileReceiptGridReducerAction.updateScreenMode("VIEW"));
          setModeSwitchDlgOpen(false);
        }, 7000);
      }
    }

    // Before switch to the modify mode check for selected application is a closed Loan.
    if (currentStateValue.receiptFor === "Application Number") {
      if (currentStateValue.branch && currentStateValue.branch !== "") {
        const applicationNumValue =
          typeof currentStateValue.applicationNum === "string"
            ? currentStateValue.applicationNum
            : currentStateValue.applicationNum[0];
        if (
          applicationNumValue &&
          applicationNumValue !== "" &&
          applicationNumValue !== null &&
          applicationNumValue !== undefined
        ) {
          const losCustomerResponse = await axios.post(
            "/losCustomer/getLoanStatusByAppNum",
            {
              appNum: applicationNumValue,
            }
          );
          const applicationLoanStatus = losCustomerResponse.data;
          if (applicationLoanStatus.status) {
            // when status is true -> loan was closed.
            setModeSwitchDialogMessage(
              "Loan was Closed for this Application Number so you can't Modify this Receipt. Please Wait Redirecting to View Mode."
            );
            setModeSwitchDialogTitleMessage("Information");
            setModeSwitchDlgOpen(true);
            setTimeout(() => {
              dispatch(FileReceiptGridReducerAction.updateScreenMode("VIEW"));
              setModeSwitchDlgOpen(false);
            }, 7000);
          } else {
            // when status is false -> loan was not closed.
            // before switching to modify mode load the Application Nums for Modify mode.
            const branchCodeValue = getSelectedBranchCode(
              currentStateValue.branch
            );
            const response = await axios.post(
              "/losCustomer/getAppListByBranch",
              {
                branchName: currentStateValue.branch,
                branchCode: branchCodeValue,
                screenMode: "MODIFY",
              }
            );
            const appnums = [...response.data];
            setApplicationNumArray([...appnums]);

            const customerIds = await axios.post(
              "/losCustomer/getCustomerIdListByBranch",
              {
                branchName: currentStateValue.branch,
                branchCode: branchCodeValue,
              }
            );
            const custIds = [...customerIds.data].map((custid) =>
              String(custid)
            );
            setCustomerIdValues([...custIds]);

            dispatch(FileReceiptGridReducerAction.updateScreenMode("MODIFY"));
          }
        } else {
          // before switching to modify mode load the Application Nums for Modify mode.
          const branchCodeValue = getSelectedBranchCode(
            currentStateValue.branch
          );
          const response = await axios.post("/losCustomer/getAppListByBranch", {
            branchName: currentStateValue.branch,
            branchCode: branchCodeValue,
            screenMode: "MODIFY",
          });
          const appnums = [...response.data];
          setApplicationNumArray([...appnums]);

          const customerIds = await axios.post(
            "/losCustomer/getCustomerIdListByBranch",
            {
              branchName: currentStateValue.branch,
              branchCode: branchCodeValue,
            }
          );
          const custIds = [...customerIds.data].map((custid) => String(custid));
          setCustomerIdValues([...custIds]);

          dispatch(FileReceiptGridReducerAction.updateScreenMode("MODIFY"));
        }
      } else {
        dispatch(FileReceiptGridReducerAction.updateScreenMode("MODIFY"));
      }
    }

    if (currentStateValue.receiptFor === "Customer ID") {
      // receipt for is customer Id.
      if (currentStateValue.branch && currentStateValue.branch !== "") {
        const voucherNumValue = currentStateValue.voucherNum;
        if (
          voucherNumValue &&
          voucherNumValue !== "" &&
          voucherNumValue !== null &&
          voucherNumValue !== undefined
        ) {
          const filereceiptAppLoanStatusResponse = await axios.post(
            "/filereceipt/getLoanStatusByVoucherNum",
            {
              voucherNum: currentStateValue.voucherNum,
            }
          );
          const filereceiptAppLoanStatus =
            filereceiptAppLoanStatusResponse.data;
          if (filereceiptAppLoanStatus.status) {
            // when status is true -> loan was closed.
            setModeSwitchDialogMessage(
              "Few Loan Applications are Closed so you can't Modify this Receipt. Please Wait Redirecting to View Mode."
            );
            setModeSwitchDialogTitleMessage("Information");
            setModeSwitchDlgOpen(true);
            setTimeout(() => {
              dispatch(FileReceiptGridReducerAction.updateScreenMode("VIEW"));
              setModeSwitchDlgOpen(false);
            }, 7000);
          } else {
            // when status is false -> loan was not closed.
            // before switching to modify mode load the Application Nums for Modify mode.
            const branchCodeValue = getSelectedBranchCode(
              currentStateValue.branch
            );
            const customerIds = await axios.post(
              "/losCustomer/getCustomerIdListByBranch",
              {
                branchName: currentStateValue.branch,
                branchCode: branchCodeValue,
              }
            );
            const custIds = [...customerIds.data].map((custid) =>
              String(custid)
            );
            setCustomerIdValues([...custIds]);

            const response = await axios.post(
              "/losCustomer/getAppListByBranch",
              {
                branchName: currentStateValue.branch,
                branchCode: branchCodeValue,
                screenMode: "MODIFY",
              }
            );
            const appnums = [...response.data];
            setApplicationNumArray([...appnums]);

            dispatch(FileReceiptGridReducerAction.updateScreenMode("MODIFY"));
          }
        } else {
          // when status is false -> loan was not closed.
          // before switching to modify mode load the Application Nums for Modify mode.
          const branchCodeValue = getSelectedBranchCode(
            currentStateValue.branch
          );
          const customerIds = await axios.post(
            "/losCustomer/getCustomerIdListByBranch",
            {
              branchName: currentStateValue.branch,
              branchCode: branchCodeValue,
            }
          );
          const custIds = [...customerIds.data].map((custid) => String(custid));
          setCustomerIdValues([...custIds]);

          const response = await axios.post("/losCustomer/getAppListByBranch", {
            branchName: currentStateValue.branch,
            branchCode: branchCodeValue,
            screenMode: "MODIFY",
          });
          const appnums = [...response.data];
          setApplicationNumArray([...appnums]);

          dispatch(FileReceiptGridReducerAction.updateScreenMode("MODIFY"));
        }
      } else {
        dispatch(FileReceiptGridReducerAction.updateScreenMode("MODIFY"));
      }
    }

    if (
      currentStateValue.receiptFor === null ||
      currentStateValue.receiptFor === undefined ||
      currentStateValue.receiptFor === ""
    ) {
      dispatch(FileReceiptGridReducerAction.updateScreenMode("MODIFY"));
    }
  };

  const BasicContent = (
    <>
      <Box>
        <Grid container rowSpacing={0} columnSpacing={2}>
          <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
            <CustomAutoComplete
              disabled={false}
              required={true}
              label="Branch"
              id="branch"
              variant="standard"
              type="text"
              placeholder="Select Branch"
              autoCompleteValues={branchNames}
              value={props.fileReceiptState.branch}
              onChange={(event, value) => {
                setBranchHasError(
                  value !== null && value !== "" && value !== undefined
                    ? false
                    : true
                );
                let currentStateValue = { ...props.fileReceiptState };
                currentStateValue.branch = value;
                currentStateValue.prepayReceiptMode =
                  store.getState().fileReceiptGrid.prepayReceiptMode;
                const prepayDetails =
                  store.getState().fileReceiptGrid.prePayDetails;
                currentStateValue = { ...currentStateValue, ...prepayDetails };
                if (
                  props.screenMode !== "VIEW" &&
                  Object.keys(fileReceiptInitialStateAfterFilter).length > 0 &&
                  JSON.stringify(currentStateValue) !==
                    JSON.stringify(fileReceiptInitialStateAfterFilter)
                ) {
                  openAlertDialog(
                    props.fileReceiptScreenFields.branch,
                    value !== null && value !== "" && value !== undefined
                      ? value.label
                      : null
                  );
                } else {
                  onBranchChange(value, false);
                }
              }}
            />
            {branchHasError && <p className="error">Please Select Branch</p>}
          </Grid>

          <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
            <CustomAutoComplete
              disabled={false}
              required={true}
              label="Receipt For"
              id="receiptFor"
              variant="standard"
              type="text"
              placeholder="Select Receipt For"
              autoCompleteValues={
                fileReceiptLovData.lovDataValue?.["Receipt For"]
                  ? fileReceiptLovData.lovDataValue?.["Receipt For"].map(
                      (record) => record.lovValues
                    )
                  : []
              }
              value={props.fileReceiptState.receiptFor}
              onChange={(event, value) => {
                setReceiptForHasError(
                  value !== null && value !== "" && value !== undefined
                    ? false
                    : true
                );
                let currentStateValue = { ...props.fileReceiptState };
                currentStateValue.receiptFor = value;
                currentStateValue.prepayReceiptMode =
                  store.getState().fileReceiptGrid.prepayReceiptMode;
                const prepayDetails =
                  store.getState().fileReceiptGrid.prePayDetails;
                currentStateValue = { ...currentStateValue, ...prepayDetails };
                if (
                  props.screenMode !== "VIEW" &&
                  Object.keys(fileReceiptInitialStateAfterFilter).length > 0 &&
                  JSON.stringify(currentStateValue) !==
                    JSON.stringify(fileReceiptInitialStateAfterFilter)
                ) {
                  openAlertDialog(
                    props.fileReceiptScreenFields.receiptFor,
                    value
                  );
                } else {
                  onChangeByReceiptFor(value);
                }
              }}
            />
            {receiptForHasError && (
              <p className="error">Please Select Receipt For</p>
            )}
          </Grid>

          {props.fileReceiptState.receiptFor === "Customer ID" && (
            <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
              <CustomAutoComplete
                disabled={false}
                required={true}
                label="Customer ID"
                id="customerId"
                variant="standard"
                type="text"
                placeholder="Select Customer ID"
                autoCompleteValues={customerIdValues}
                value={props.fileReceiptState.customerId}
                onChange={(event, value) => {
                  setCustomerIdHasError(
                    value !== null && value !== "" && value !== undefined
                      ? false
                      : true
                  );
                  let currentStateValue = { ...props.fileReceiptState };
                  currentStateValue.customerId = value;
                  currentStateValue.prepayReceiptMode =
                    store.getState().fileReceiptGrid.prepayReceiptMode;
                  const prepayDetails =
                    store.getState().fileReceiptGrid.prePayDetails;
                  currentStateValue = {
                    ...currentStateValue,
                    ...prepayDetails,
                  };
                  if (
                    props.screenMode !== "VIEW" &&
                    Object.keys(fileReceiptInitialStateAfterFilter).length >
                      0 &&
                    JSON.stringify(currentStateValue) !==
                      JSON.stringify(fileReceiptInitialStateAfterFilter)
                  ) {
                    openAlertDialog(
                      props.fileReceiptScreenFields.customerId,
                      value
                    );
                  } else {
                    onChangeByCustomerId(value, false);
                  }
                }}
              />
              {customerIdHasError && (
                <p className="error">Please Select Customer ID</p>
              )}
            </Grid>
          )}

          {props.fileReceiptState.receiptFor === "Application Number" && (
            <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
              <CustomAutoComplete
                disabled={false}
                required={true}
                label="Application Number"
                id="applicationNum"
                variant="standard"
                type="text"
                placeholder="Select Application Number"
                autoCompleteValues={applicationNumValues}
                value={props.fileReceiptState.applicationNum}
                onChange={(event, value) => {
                  setApplicationNumberHasError(
                    value !== null && value !== "" && value !== undefined
                      ? false
                      : true
                  );
                  let currentStateValue = { ...props.fileReceiptState };
                  currentStateValue.applicationNum = value;
                  currentStateValue.prepayReceiptMode =
                    store.getState().fileReceiptGrid.prepayReceiptMode;
                  const prepayDetails =
                    store.getState().fileReceiptGrid.prePayDetails;
                  currentStateValue = {
                    ...currentStateValue,
                    ...prepayDetails,
                  };
                  if (
                    props.screenMode !== "VIEW" &&
                    Object.keys(fileReceiptInitialStateAfterFilter).length >
                      0 &&
                    JSON.stringify(currentStateValue) !==
                      JSON.stringify(fileReceiptInitialStateAfterFilter)
                  ) {
                    openAlertDialog(
                      props.fileReceiptScreenFields.applicationNum,
                      value
                    );
                  } else {
                    onChangeByAppNum(value, false);
                  }
                }}
              />
              {applicationNumberHasError && (
                <p className="error">Please Select Application Number</p>
              )}
            </Grid>
          )}

          {(props.screenMode === "MODIFY" || props.screenMode === "VIEW") && (
            <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
              <CustomAutoComplete
                disabled={false}
                required={true}
                label="Voucher Number"
                id="voucherNumber"
                variant="standard"
                type="text"
                placeholder="Select Voucher Number"
                autoCompleteValues={voucherNums}
                value={props.fileReceiptState.voucherNum}
                onChange={(event, value) => {
                  props.goClickEvent(false);
                  setVoucherNumberHasError(
                    value !== null && value !== "" && value !== undefined
                      ? false
                      : true
                  );
                  if (value) {
                    onChangeVoucherNum(value);
                  } else {
                    dispatch(FileReceiptGridReducerAction.resetGridRows());
                    dispatch(
                      FileReceiptGridReducerAction.updateInitialLoad(true)
                    );
                    dispatch(FileReceiptGridReducerAction.updateGridRows([]));
                    let responseReceiptData = { ...fileReceiptInitialState };
                    responseReceiptData.branch = props.fileReceiptState.branch;
                    responseReceiptData.receiptFor =
                      props.fileReceiptState.receiptFor;
                    responseReceiptData.applicationNum =
                      props.fileReceiptState.applicationNum;
                    responseReceiptData.customerId =
                      props.fileReceiptState.customerId;
                    responseReceiptData.voucherNum = value;
                    props.dispatch({
                      type: "viewOrModifyModeLoad",
                      value: responseReceiptData,
                    });
                  }
                }}
              />
              {voucherNumberHasError && (
                <p className="error">Please Select Voucher Number</p>
              )}
            </Grid>
          )}

          <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
            <CustomDateField
              disabled={props.screenMode === "VIEW"}
              required={props.screenMode !== "VIEW"}
              label="Voucher Date"
              id="voucherDate"
              variant="standard"
              value={props.fileReceiptState.voucherDate}
              minDate={new Date().setDate(
                new Date().getDate() - minDateAddValue
              )}
              maxDate={new Date().setDate(
                new Date().getDate() + maxDateAddValue
              )}
              onOpen={() => {
                let dateMap = {
                  chequeDateEnable: false,
                  bankDateEnable: false,
                  voucherDateEnable: true,
                  bankingDateEnable: false,
                  realizationDateEnable: false,
                };
                dispatch(
                  FileReceiptGridReducerAction.updateDateEnableDetails(dateMap)
                );
              }}
              // maxDate={"2055/12/31"}
              type="text"
              placeholder=""
              onChange={(event) => {
                if (event !== null && event !== undefined && event !== "") {
                  const newDateValue = `${new Date(event).getFullYear()}/${
                    new Date(event).getMonth() + 1 > 9
                      ? new Date(event).getMonth() + 1
                      : "0" + Number(new Date(event).getMonth() + 1)
                  }/${
                    new Date(event).getDate() > 9
                      ? new Date(event).getDate()
                      : "0" + Number(new Date(event).getDate())
                  }`;
                  const maxValue = new Date().setDate(
                    new Date().getDate() + maxDateAddValue
                  );
                  const maxDateValue = `${new Date(maxValue).getFullYear()}/${
                    new Date(maxValue).getMonth() + 1 > 9
                      ? new Date(maxValue).getMonth() + 1
                      : "0" + Number(new Date(maxValue).getMonth() + 1)
                  }/${
                    new Date(maxValue).getDate() > 9
                      ? new Date(maxValue).getDate()
                      : "0" + Number(new Date(maxValue).getDate())
                  }`;
                  const minValue = new Date().setDate(
                    new Date().getDate() - minDateAddValue
                  );
                  const minDateValue = `${new Date(minValue).getFullYear()}/${
                    new Date(minValue).getMonth() + 1 > 9
                      ? new Date(minValue).getMonth() + 1
                      : "0" + Number(new Date(minValue).getMonth() + 1)
                  }/${
                    new Date(minValue).getDate() > 9
                      ? new Date(minValue).getDate()
                      : "0" + Number(new Date(minValue).getDate())
                  }`;
                  const specialAccessMaxFlag = newDateValue > maxDateValue;
                  const specialAccessMinFlag = newDateValue < minDateValue;
                  const invalidDate =
                    new Date(event).toDateString() !== "Invalid Date";
                  let validFlag = false;
                  if (
                    new Date(event).toLocaleDateString().slice(-4) >= "2055" ||
                    new Date(event).toLocaleDateString().slice(-4) <= "1970"
                  ) {
                    validFlag = true;
                  } else if (
                    new Date(event).toLocaleDateString().slice(-4) <= "2055" &&
                    new Date(event).toLocaleDateString().slice(-4) >= "1970"
                  ) {
                    validFlag = specialAccessMaxFlag || specialAccessMinFlag;
                  }

                  dispatch(
                    FileReceiptGridReducerAction.updateVoucherDateValidDateError(
                      invalidDate && validFlag
                    )
                  );
                } else {
                  // means date field is empty.
                  dispatch(
                    FileReceiptGridReducerAction.updateVoucherDateValidDateError(
                      true
                    )
                  );
                }
                props.dispatch({
                  type: props.fileReceiptScreenFields.voucherDate,
                  value: event,
                });
                if (prepayReceiptMode) {
                  dispatch(
                    FileReceiptGridReducerAction.updatePrepayEffectiveDate(
                      event
                    )
                  );
                }
              }}
            />
            {voucherDateValidDateError && (
              <p className="error">Please Enter Valid Voucher Date</p>
            )}
          </Grid>

          <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
            <CustomTextField
              disabled={true}
              required={false}
              label="Applicant Name"
              id="customerName"
              variant="standard"
              value={props.fileReceiptState.customerName}
              type="text"
              placeholder="Applicant Name"
              onChange={(event) => {
                props.dispatch({
                  type: props.fileReceiptScreenFields.customerName,
                  value: event.target.value,
                });
              }}
            />
          </Grid>

          {/* <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
            <CustomTextField
              disabled={disableFields}
              required={false}
              label="Reference"
              id="reference"
              variant="standard"
              value={props.fileReceiptState.reference}
              type="text"
              placeholder="Reference"
              onChange={(event) => {
                props.dispatch({
                  type: props.fileReceiptScreenFields.reference,
                  value: event.target.value,
                });
              }}
            />
          </Grid> */}

          {/* <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
            <CustomTextField
              disabled={true}
              required={false}
              label="Disbursement Status"
              id="disbStatus"
              variant="standard"
              value={props.fileReceiptState.disbStatus}
              type="text"
              placeholder="Disbursement Status"
              onChange={(event) => {
                props.dispatch({
                  type: props.fileReceiptScreenFields.disbStatus,
                  value: event.target.value,
                });
              }}
            />
          </Grid> */}

          <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
            <CustomAutoComplete
              type="text"
              disabled={disableFields}
              required={props.screenMode === "CREATE"}
              label="Receipt Type"
              id="receiptType"
              variant="standard"
              placeholder={
                props.screenMode === "CREATE"
                  ? "Select Receipt Type"
                  : "Receipt Type"
              }
              autoCompleteValues={receiptTypeValues}
              value={props.fileReceiptState.receiptType}
              onChange={(event, value) => {
                setReceiptTypeHasError(
                  value !== null && value !== "" && value !== undefined
                    ? false
                    : true
                );
                let currentStateValue = { ...props.fileReceiptState };
                currentStateValue.receiptType = value;
                currentStateValue.prepayReceiptMode =
                  store.getState().fileReceiptGrid.prepayReceiptMode;
                const prepayDetails =
                  store.getState().fileReceiptGrid.prePayDetails;
                currentStateValue = { ...currentStateValue, ...prepayDetails };
                if (
                  props.screenMode !== "VIEW" &&
                  Object.keys(fileReceiptInitialStateAfterFilter).length > 0 &&
                  JSON.stringify(currentStateValue) !==
                    JSON.stringify(fileReceiptInitialStateAfterFilter)
                ) {
                  openAlertDialog(
                    props.fileReceiptScreenFields.receiptType,
                    value
                  );
                } else {
                  props.dispatch({
                    type: props.fileReceiptScreenFields.receiptType,
                    value: value,
                  });
                }
              }}
            />
            {receiptTypeHasError && props.screenMode === "CREATE" && (
              <p className="error">Please Select Receipt Type</p>
            )}
          </Grid>
        </Grid>

        <Box
          sx={{
            marginTop: "8px",
            display: "flex",
            justifyContent: "center",
          }}
        >
          <Tooltip title="Ctrl+F" placement="top">
            <Button
              variant="contained"
              type="submit"
              sx={{ height: "2rem" }}
              onClick={() => validateFieldsHandler()}
              ref={searchButtonRef}
            >
              Go
            </Button>
          </Tooltip>
          <Tooltip title="Ctrl+D" placement="top">
            <Button
              sx={{
                marginLeft: "1rem",
                color: "white",
                backgroundColor: "black",
                height: "2rem",
              }}
              onMouseOver={({ target }) => {
                target.style.backgroundColor = "black";
                target.style.color = "white";
              }}
              variant="contained"
              onClick={() => {
                setBranchHasError(false);
                setApplicationNumberHasError(false);
                setReceiptForHasError(false);
                setCustomerIdHasError(false);
                setVoucherNumberHasError(false);
                setReceiptTypeHasError(false);
                setCurrentFieldTrigger({});
                props.goClickEvent(false);
                dispatch(
                  FileReceiptGridReducerAction.updateFileReceiptInitialStateAfterFilter(
                    {}
                  )
                );
                props.dispatch({
                  type: "resetInitialState",
                  value: null,
                });
              }}
              ref={clearRef}
            >
              Clear
            </Button>
          </Tooltip>
        </Box>
      </Box>
    </>
  );

  return (
    <>
      <AccordianContainer
        title={props.screenTitle}
        initialOpen={accodianOpen}
        setAccordianOpen={setAccordianOpen}
      >
        <Box
          sx={{
            width: "100%",
            backgroundColor: "white",
            marginBottom: "12px",
            marginTop: "-2%",
          }}
        >
          {props.screenMode !== "CREATE" && (
            <Box
              sx={{
                marginBottom: "8px",
                marginTop: "-1%",
                display: "flex",
                gap: "8px",
                justifyContent: "flex-end",
              }}
            >
              {specialAccessHeaderMap.fileReceiptView && (
                <Tooltip title="Ctrl+E" placement="top">
                  <IconButton
                    aria-label="View"
                    color="primary"
                    onClick={() => {
                      onSwitchToViewMode();
                    }}
                    ref={viewRef}
                  >
                    <Preview />
                  </IconButton>
                </Tooltip>
              )}
              {specialAccessHeaderMap.fileReceiptModify && (
                <Tooltip title="Ctrl+M" placement="top">
                  <IconButton
                    aria-label="Modify"
                    color="primary"
                    onClick={() => {
                      onSwitchToModifyMode();
                    }}
                    ref={modifyRef}
                  >
                    <Edit />
                  </IconButton>
                </Tooltip>
              )}
            </Box>
          )}
          {BasicContent}
        </Box>
        <Dialog open={open} aria-describedby="alert-dialog-slide-description">
          <DialogTitle>{dialogTitleMessage}</DialogTitle>
          <DialogContent>
            <DialogContentText id="alert-dialog-slide-description">
              {dialogMessage}
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Tooltip title="Ctrl+Q" placement="top">
              <Button onClick={handleClose} ref={cancelRef}>
                Cancel
              </Button>
            </Tooltip>
            <Tooltip title="Ctrl+Y" placement="top">
              <Button onClick={handleOk} ref={yesRef}>
                Yes
              </Button>
            </Tooltip>
          </DialogActions>
        </Dialog>
        <Dialog
          open={modeSwitchDlgOpen}
          aria-describedby="alert-dialog-slide-description"
        >
          <DialogTitle>{modeSwitchDialogTitleMessage}</DialogTitle>
          <DialogContent>
            <DialogContentText id="alert-dialog-slide-description">
              {modeSwitchDialogMessage}
            </DialogContentText>
          </DialogContent>
          {modeSwitchToView && (
            <DialogActions>
              <Tooltip title="Ctrl+Q" placement="top">
                <Button onClick={handleCloseForModeSwitch} ref={cancelModeRef}>
                  Cancel
                </Button>
              </Tooltip>
              <Tooltip title="Ctrl+Y" placement="top">
                <Button onClick={handleOkForModeSwitch} ref={yesModeRef}>
                  Yes
                </Button>
              </Tooltip>
            </DialogActions>
          )}
        </Dialog>
      </AccordianContainer>
    </>
  );
};

export default BasicReceiptInfo;
